import React, { Component } from "react";
import "./App.scss";
import { Router, Route } from "react-router-dom";
import SearchBox from "./components/search-box.js";
import history from "./utils/HistoryApp";
import SelectCity from "./components/select-city";
import LoginScreen from "./components/login/login-screen";
import Buslisting from "./components/bus-listing";
import SeatLayout from "./components/seat-layout";
import Passenger from "./components/passenger-page";
import CancelTicket from "./components/cancel-ticket";
import TicketSummary from "./components/ticket-summary";
import Ticket from "./components/ticket";
import TicketFail from "./components/transaction-fail";
import Trips from "./components/trips";
import BusFilter from "./components/bus-filters";
import BoardDropingPoints from "./components/select-filter";

export default class App extends Component {
  render() {
    return (
      <Router history={history} basename={"/bus-booking-phonepe"}>
        <Route
          exact
          path="/bus-booking-phonepe/index.html"
          component={SearchBox}
        />
        <Route exact path="/bus-booking-phonepe" component={SearchBox} />
        <Route path="/select-city/:type" component={SelectCity} />
        <Route
          path="/bus-booking-phonepe/account-login"
          component={LoginScreen}
        />
        <Route path="/bus-booking-phonepe/filters" component={BusFilter} />
        <Route
          path="/bus-booking-phonepe/select-filter/:type"
          component={BoardDropingPoints}
        />
        <Route
          path="/bus-booking-phonepe/from/:from/to/:to/:doj"
          component={Buslisting}
        />
        <Route path="/bus-booking-phonepe/seat-select" component={SeatLayout} />
        <Route
          path="/bus-booking-phonepe/passenger-page"
          component={Passenger}
        />
        <Route
          path="/bus-booking-phonepe/ticket-summary"
          component={TicketSummary}
        />
        <Route
          path="/bus-booking-phonepe/ticket/:bookingId/:email/:provider/:type?"
          component={Ticket}
        />
        <Route
          path="/bus-booking-phonepe/transaction-fail"
          component={TicketFail}
        ></Route>

        <Route path="/bus-booking-phonepe/trips" component={Trips} />

        <Route
          path="/bus-booking-phonepe/cancel-ticket/:bookingId?/:email?"
          component={CancelTicket}
        />
      </Router>
    );
  }
}
